"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fields = exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _cccisdReduxFormHelpers = require("cccisd-redux-form-helpers");
var _cccisdColorPicker = _interopRequireWildcard(require("cccisd-color-picker"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var colorFields = ['displayOptions.portal.titleColor', 'displayOptions.portal.infoBarAccentColor', 'displayOptions.portal.searchBarColor', 'displayOptions.portal.backgroundColor', 'displayOptions.portal.filterHeaderColor', 'displayOptions.portal.filterHeaderBackgroundColor', 'displayOptions.portal.filterCollapseColor', 'displayOptions.portal.filterGroupColor', 'displayOptions.portal.tabActiveColor', 'displayOptions.portal.tabInactiveColor', 'displayOptions.portal.tabTextColor', 'displayOptions.portal.tabTextActiveColor', 'displayOptions.portal.resourceCountLabelColor', 'displayOptions.portal.defaultPerPageOption', 'displayOptions.portal.infoBarTextColor', 'displayOptions.portal.filterGroupTextColor', 'displayOptions.resources.titleColor', 'displayOptions.resources.shareButtonColor', 'displayOptions.resources.favoriteButtonColor', 'displayOptions.resources.descriptionTextColor'];
var fields = exports.fields = [].concat(colorFields);
var _default = exports["default"] = function _default(props) {
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    showColorOptions = _useState2[0],
    handleShowColorOptions = _useState2[1];
  var displayOptions = props.fields.displayOptions;
  var _displayOptions$porta = displayOptions.portal,
    titleColor = _displayOptions$porta.titleColor,
    infoBarAccentColor = _displayOptions$porta.infoBarAccentColor,
    searchBarColor = _displayOptions$porta.searchBarColor,
    backgroundColor = _displayOptions$porta.backgroundColor,
    filterHeaderColor = _displayOptions$porta.filterHeaderColor,
    filterHeaderBackgroundColor = _displayOptions$porta.filterHeaderBackgroundColor,
    filterCollapseColor = _displayOptions$porta.filterCollapseColor,
    filterGroupColor = _displayOptions$porta.filterGroupColor,
    tabActiveColor = _displayOptions$porta.tabActiveColor,
    tabInactiveColor = _displayOptions$porta.tabInactiveColor,
    tabTextColor = _displayOptions$porta.tabTextColor,
    tabTextActiveColor = _displayOptions$porta.tabTextActiveColor,
    resourceCountLabelColor = _displayOptions$porta.resourceCountLabelColor,
    infoBarTextColor = _displayOptions$porta.infoBarTextColor,
    filterGroupTextColor = _displayOptions$porta.filterGroupTextColor;
  var _displayOptions$resou = displayOptions.resources,
    shareButtonColor = _displayOptions$resou.shareButtonColor,
    favoriteButtonColor = _displayOptions$resou.favoriteButtonColor,
    descriptionTextColor = _displayOptions$resou.descriptionTextColor;
  var colors = [{
    field: titleColor,
    label: 'Title Color'
  }, {
    field: infoBarAccentColor,
    label: 'Info Bar Accent Color'
  }, {
    field: searchBarColor,
    label: 'Search Bar Color'
  }, {
    field: backgroundColor,
    label: 'Background Color'
  }, {
    field: filterHeaderColor,
    label: 'Filter Header Color'
  }, {
    field: filterHeaderBackgroundColor,
    label: 'Filter Header BG Color'
  }, {
    field: filterCollapseColor,
    label: 'Filter Collapse Color'
  }, {
    field: filterGroupColor,
    label: 'Filter Group Color'
  }, {
    field: tabActiveColor,
    label: 'Tab Active Color'
  }, {
    field: tabInactiveColor,
    label: 'Tab Inactive Color'
  }, {
    field: tabTextColor,
    label: 'Inactive Tab Text Color'
  }, {
    field: tabTextActiveColor,
    label: 'Active Tab Text Color'
  }, {
    field: resourceCountLabelColor,
    label: 'Resource Count Label Color'
  }, {
    field: displayOptions.resources.titleColor,
    label: 'Resource Title Color'
  }, {
    field: shareButtonColor,
    label: 'Share Button Color'
  }, {
    field: favoriteButtonColor,
    label: 'Favorite Button Color'
  }, {
    field: infoBarTextColor,
    label: 'Header Text Color'
  }];
  var handleChange = function handleChange(color, fieldsList) {
    color = (0, _cccisdColorPicker.getColor)(color);
    fieldsList.forEach(function (field) {
      return field.onChange(color);
    });
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "card"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "card-body",
    style: {
      backgroundColor: '#F5F5F5'
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-3"
  }, /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, {
    field: tabActiveColor,
    label: "Primary Color"
  }, /*#__PURE__*/_react["default"].createElement(_cccisdColorPicker["default"], {
    value: tabActiveColor.value,
    onChange: function onChange(color) {
      return handleChange(color, [tabActiveColor]);
    }
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-3"
  }, /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, {
    field: infoBarAccentColor,
    label: "Secondary Color"
  }, /*#__PURE__*/_react["default"].createElement(_cccisdColorPicker["default"], {
    value: infoBarAccentColor.value,
    onChange: function onChange(color) {
      return handleChange(color, [infoBarAccentColor, shareButtonColor, filterCollapseColor]);
    }
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-3"
  }, /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, {
    field: titleColor,
    label: "Primary Text Color"
  }, /*#__PURE__*/_react["default"].createElement(_cccisdColorPicker["default"], {
    value: titleColor.value,
    onChange: function onChange(color) {
      return handleChange(color, [titleColor, displayOptions.resources.titleColor, filterHeaderColor]);
    }
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-3"
  }, /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, {
    field: descriptionTextColor,
    label: "Secondary Text Color"
  }, /*#__PURE__*/_react["default"].createElement(_cccisdColorPicker["default"], {
    value: descriptionTextColor.value,
    onChange: function onChange(color) {
      return handleChange(color, [descriptionTextColor, filterGroupTextColor, resourceCountLabelColor]);
    }
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-12",
    style: {
      marginBottom: '15px'
    }
  }, /*#__PURE__*/_react["default"].createElement("a", {
    onClick: function onClick() {
      return handleShowColorOptions(function (prevState) {
        return !prevState;
      });
    }
  }, showColorOptions ? 'Nevermind...' : 'I need finer control...')), showColorOptions && colors.map(function (color) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "col-3",
      key: color.label
    }, /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, {
      field: color.field,
      label: color.label
    }, /*#__PURE__*/_react["default"].createElement(_cccisdColorPicker["default"], {
      value: color.field.value,
      onChange: function onChange(c) {
        return color.field.onChange((0, _cccisdColorPicker.getColor)(c));
      }
    })));
  }))));
};